export const APP_VERSION = '1e3db470-1792401486400'
